interface CarouselItem {
  title: string;
  subtitle: string;
  tag: string;
  imageAlt: string;
  imageUrl: string;
}

const carouselItems: CarouselItem[] = [
  {
    title: '《欢乐喜剧人》巅峰对决',
    subtitle: '新一季喜剧人集结，笑料不断，每一场表演都是经典',
    tag: '热播中',
    imageAlt: '天天影视欢乐喜剧人热门综艺专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Comedy%20stage%20performance%20with%20bright%20colorful%20spotlights%2C%20energetic%20atmosphere%2C%20comedian%20on%20stage%2C%20vibrant%20warm%20lighting%2C%20entertainment%20show%20production&width=800&height=500&seq=carousel-01&orientation=landscape',
  },
  {
    title: '《奔跑吧》户外特辑',
    subtitle: '跑男团集结出发，户外挑战升级，欢乐与刺激并存',
    tag: '热门',
    imageAlt: '天天影视奔跑吧户外真人秀专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Outdoor%20adventure%20scene%20with%20team%20running%20on%20green%20field%2C%20bright%20sunlight%2C%20dynamic%20sports%20atmosphere%2C%20wide%20angle%20landscape%2C%20energetic%20vibe&width=800&height=500&seq=carousel-02&orientation=landscape',
  },
  {
    title: '《向往的生活》田园时光',
    subtitle: '回归自然的慢生活综艺，感受质朴田园的温暖与治愈',
    tag: '治愈',
    imageAlt: '天天影视向往的生活田园综艺专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Peaceful%20countryside%20courtyard%20with%20wooden%20house%20and%20green%20plants%2C%20warm%20sunset%20glow%2C%20rustic%20charm%2C%20cozy%20outdoor%20living%2C%20natural%20and%20serene%20atmosphere&width=800&height=500&seq=carousel-03&orientation=landscape',
  },
  {
    title: '《脱口秀大会》爆笑集锦',
    subtitle: '新老脱口秀演员同台竞技，犀利段子幽默不停',
    tag: '爆笑',
    imageAlt: '天天影视脱口秀大会爆笑综艺专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stand%20up%20comedy%20stage%20with%20single%20microphone%20under%20spotlight%2C%20theater%20setting%2C%20warm%20intimate%20lighting%2C%20dark%20background%2C%20professional%20stage%20design&width=800&height=500&seq=carousel-04&orientation=landscape',
  },
  {
    title: '《中国好声音》经典回顾',
    subtitle: '历年好声音经典舞台回顾，重温那些震撼人心的歌声',
    tag: '经典',
    imageAlt: '天天影视中国好声音经典舞台综艺专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20talent%20show%20stage%20with%20dramatic%20red%20and%20golden%20lighting%2C%20singing%20performance%2C%20grand%20theater%20atmosphere%2C%20emotional%20moment%2C%20professional%20concert%20production&width=800&height=500&seq=carousel-05&orientation=landscape',
  },
  {
    title: '《密室大逃脱》刺激挑战',
    subtitle: '明星嘉宾勇闯密室，烧脑解谜与团队协作的极致体验',
    tag: '烧脑',
    imageAlt: '天天影视密室大逃脱刺激综艺专题',
    imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20escape%20room%20interior%20with%20dim%20dramatic%20lighting%2C%20puzzle%20elements%20and%20clues%2C%20atmospheric%20room%20design%2C%20suspenseful%20vibe%2C%20cinematic%20composition&width=800&height=500&seq=carousel-06&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full uppercase tracking-wide mb-3">
            焦点专题
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3">
            热门综艺聚焦
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            六大热门综艺专题，一网打尽当下最值得追的精彩节目
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.imageUrl}
              className="group relative bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.imageUrl}
                  alt={item.imageAlt}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="bg-accent-500 text-background-50 text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 w-full p-4">
                  <h3 className="text-white text-base md:text-lg font-bold mb-1 drop-shadow-sm">
                    {item.title}
                  </h3>
                  <p className="text-white/85 text-xs md:text-sm line-clamp-2 drop-shadow-sm">
                    {item.subtitle}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}